module.exports = __webpack_public_path__ + "static/media/Space Creature.d0fc647c.jpg";